import { render, staticRenderFns } from "./grid-col-span-editor.vue?vue&type=template&id=0a1c49ae&scoped=true&"
import script from "./grid-col-span-editor.vue?vue&type=script&lang=js&"
export * from "./grid-col-span-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1c49ae",
  null
  
)

export default component.exports